import { render, staticRenderFns } from "./printer-select.vue?vue&type=template&id=b89051b6&scoped=true"
import script from "./printer-select.vue?vue&type=script&setup=true&lang=js"
export * from "./printer-select.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89051b6",
  null
  
)

export default component.exports